export default {
  env: 'test',
  assetsEndpoint: 'https://static.test.mdirector.com/assets/',
  storage: {
    domain: 'https://app.test.mdirector.com',
    file: '/storage.php',
  },
  services: {
    email_marketing: { frontUrl: 'https://app.test.mdirector.com' },
    email_transactional: { frontUrl: 'https://trans.test.mdirector.com' },
    marketing_automation: { frontUrl: 'https://automation.test.mdirector.com' },
    landing_optimizer: { frontUrl: 'https://landings.test.mdirector.com' },
    payments: { frontUrl: 'https://payments.test.mdirector.com' },
    integrations: {
      frontUrl: 'https://signup.test.mdirector.com',
      zapier: true,
      shopify: true,
      apis: true,
    },
  },
};
